import {
  GET_JACKPOT_PAYOUT_FOR_DRAWS,
  GET_JACKPOT_RESULTS_FOR_DRAW,
  GET_LATEST_JACKPOT_RESULTS,
  IJackpotGameResult,
  IJackpotGameResultData,
  IJackpotPayout,
  SEND_PLAYERS_DATA_FOR_JACKPOT
} from '@pbl/pbl-react-core/lib/models/games/types';
import { FAILURE, REQUEST, SUCCESS } from 'redux/action-type.util';
import { IDispatchAction } from '../index';

export interface IGamesState {
  loading: boolean;
  errorMessage: any;
  jackpotResult: IJackpotGameResult;
  resultData: IJackpotGameResultData[];
  payout?: IJackpotPayout;
  gameNumbers: number[];
  nextDraw: any;
  latestDraw: any;
}

const INITIAL_STATE: IGamesState = {
  loading: false,
  errorMessage: null,
  jackpotResult: {} as IJackpotGameResult,
  resultData: [],
  payout: { value: -1 },
  gameNumbers: [],
  nextDraw: null,
  latestDraw: null
};

export type GamesState = Readonly<IGamesState>;
export default (state: GamesState = INITIAL_STATE, action: IDispatchAction): GamesState => {
  switch (action.type) {
    case REQUEST(GET_LATEST_JACKPOT_RESULTS):
    case REQUEST(GET_JACKPOT_RESULTS_FOR_DRAW):
    case REQUEST(SEND_PLAYERS_DATA_FOR_JACKPOT):
    case REQUEST(GET_JACKPOT_PAYOUT_FOR_DRAWS):
    case REQUEST('GET_NEXT_JACKPOT_RESULTS_FOR_DRAW'):
    case REQUEST('GET_LATEST_RESULTS_FOR_DRAW'):
      return {
        ...state,
        loading: true
      };
    case SUCCESS(GET_LATEST_JACKPOT_RESULTS):
    case SUCCESS(GET_JACKPOT_RESULTS_FOR_DRAW):
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
        ...action.payload
      };
    case SUCCESS(SEND_PLAYERS_DATA_FOR_JACKPOT):
      return {
        ...state,
        loading: false,
        errorMessage: null,
        payout: action.payload.payout
      };
    case SUCCESS('GET_NEXT_JACKPOT_RESULTS_FOR_DRAW'): {
      return {
        ...state,
        loading: false,
        errorMessage: null,
        nextDraw: action.payload
      };
    }
    case SUCCESS('GET_LATEST_RESULTS_FOR_DRAW'): {
      return {
        ...state,
        loading: false,
        errorMessage: null,
        latestDraw: action.payload
      };
    }
    case FAILURE(GET_LATEST_JACKPOT_RESULTS):
    case FAILURE(GET_JACKPOT_RESULTS_FOR_DRAW):
    case FAILURE(SEND_PLAYERS_DATA_FOR_JACKPOT):
    case FAILURE(GET_JACKPOT_PAYOUT_FOR_DRAWS):
    case FAILURE('GET_NEXT_JACKPOT_RESULTS_FOR_DRAW'):
    case FAILURE('GET_LATEST_RESULTS_FOR_DRAW'):
      return {
        ...state,
        loading: false,
        errorMessage: action.payload
      };
    case 'RESET_JACKPOT': {
      return INITIAL_STATE;
    }
    case 'RESET_JACKPOT_ERROR': {
      return {
        ...state,
        errorMessage: null
      };
    }
    default:
      return state;
  }
};
